import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["selectedValues", "name", "placeholder", "customSelectedText", "onChange", "loading", "options", "onBlur", "onSearch"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import "core-js/modules/es.function.name.js";
// @ts-nocheck
import React, { useState, createElement as _createElement } from "react";
import { Autocomplete, Chip, ListItemText, TextField, Box, makeStyles } from "componentLibrary";
import { Checkbox } from "client/componentLibrary";
import FieldBase from "componentLibrary/Fields/FieldBase";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function () {
  return {
    chipContainer: {
      display: "flex",
      flexWrap: "wrap",
      gap: "8px",
      marginTop: "8px"
    },
    chip: {
      borderRadius: "16px",
      border: "1px solid #007AFF",
      backgroundColor: "#E8F0FE",
      color: "#007AFF",
      fontWeight: 500
    }
  };
});
var MultiSelectField = function MultiSelectField(_ref) {
  var _ref$selectedValues = _ref.selectedValues,
    selectedValues = _ref$selectedValues === void 0 ? [] : _ref$selectedValues,
    name = _ref.name,
    placeholder = _ref.placeholder,
    _ref$customSelectedTe = _ref.customSelectedText,
    customSelectedText = _ref$customSelectedTe === void 0 ? null : _ref$customSelectedTe,
    onChange = _ref.onChange,
    loading = _ref.loading,
    options = _ref.options,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
    _ref$onSearch = _ref.onSearch,
    onSearch = _ref$onSearch === void 0 ? function () {} : _ref$onSearch,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var _useState3 = useState(_filterInstanceProperty(options).call(options, function (option) {
      return _includesInstanceProperty(selectedValues).call(selectedValues, option.value);
    })),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var handleInputChange = function handleInputChange(event, newInputValue, reason) {
    setInputValue(newInputValue);
    if (newInputValue !== "" && !_someInstanceProperty(options).call(options, function (option) {
      var _context;
      return _includesInstanceProperty(_context = option.label).call(_context, newInputValue);
    })) {
      onSearch(newInputValue);
    }
  };
  var handleChange = function handleChange(event, newValue) {
    setValue(newValue);
    var updatedValues = _mapInstanceProperty(newValue).call(newValue, function (item) {
      return item.value;
    });
    onChange({
      target: {
        name: name,
        value: updatedValues
      }
    });
  };
  return /*#__PURE__*/_jsxs(FieldBase, _objectSpread(_objectSpread({
    fullWidth: true,
    InputLabelProps: {
      style: {
        position: "static"
      }
    }
  }, props), {}, {
    children: [/*#__PURE__*/_jsx(Autocomplete, {
      multiple: true,
      options: options,
      getOptionLabel: function getOptionLabel(option) {
        return option.label;
      },
      value: value,
      inputValue: inputValue,
      onInputChange: handleInputChange,
      onChange: handleChange,
      onBlur: onBlur,
      disableCloseOnSelect: true,
      renderTags: function renderTags() {
        return null;
      } // ⬅️ Hides selected values inside the input
      ,
      renderInput: function renderInput(params) {
        return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, params), {}, {
          placeholder: placeholder || "Search",
          variant: "outlined",
          size: "small"
        }));
      },
      noOptionsText: loading ? "Loading..." : "No options found",
      renderOption: function renderOption(props, option, _ref2) {
        var selected = _ref2.selected;
        return /*#__PURE__*/_createElement("li", _objectSpread(_objectSpread({}, props), {}, {
          key: option.value
        }), /*#__PURE__*/_jsx(Box, {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          children: /*#__PURE__*/_jsxs(Box, {
            display: "flex",
            alignItems: "center",
            children: [/*#__PURE__*/_jsx(Checkbox, {
              checked: selected
            }), /*#__PURE__*/_jsx(ListItemText, {
              primary: option.label
            })]
          })
        }));
      }
    }), value.length > 0 && /*#__PURE__*/_jsx(Box, {
      className: classes.chipContainer,
      children: _mapInstanceProperty(value).call(value, function (option) {
        return /*#__PURE__*/_jsx(Chip, {
          label: option.label,
          className: classes.chip,
          onDelete: function onDelete() {
            var newValues = _filterInstanceProperty(value).call(value, function (val) {
              return val.value !== option.value;
            });
            setValue(newValues);
            var updatedValues = _mapInstanceProperty(newValues).call(newValues, function (item) {
              return item.value;
            });
            onChange({
              target: {
                name: name,
                value: updatedValues
              }
            });
          }
        }, option.value);
      })
    })]
  }));
};
export default MultiSelectField;